/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsTriggerReprocessRunActionsMutationResponse, AuditReportsTriggerReprocessRunActionsPathParams, AuditReportsTriggerReprocessRunActions400, AuditReportsTriggerReprocessRunActions401, AuditReportsTriggerReprocessRunActions403, AuditReportsTriggerReprocessRunActions404 } from "../models/AuditReportsTriggerReprocessRunActions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsTriggerReprocessRunActions } from "../axios/auditReportsTriggerReprocessRunActions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsTriggerReprocessRunActionsMutationKey = () => [{ url: '/audit-reports/v1/aod-runs/:id/reprocess' }] as const

export type AuditReportsTriggerReprocessRunActionsMutationKey = ReturnType<typeof auditReportsTriggerReprocessRunActionsMutationKey>

export function auditReportsTriggerReprocessRunActionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = auditReportsTriggerReprocessRunActionsMutationKey()
        return mutationOptions<AuditReportsTriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessRunActions400 | AuditReportsTriggerReprocessRunActions401 | AuditReportsTriggerReprocessRunActions403 | AuditReportsTriggerReprocessRunActions404>, {id: AuditReportsTriggerReprocessRunActionsPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return auditReportsTriggerReprocessRunActions(id, config)
          },
        })

}

/**
 * @description Triggers a reprocess of the order associated with a run using the Olaf API
 * @summary Trigger Olaf reprocess for a run
 * {@link /audit-reports/v1/aod-runs/:id/reprocess}
 */
export function useAuditReportsTriggerReprocessRunActions<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsTriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessRunActions400 | AuditReportsTriggerReprocessRunActions401 | AuditReportsTriggerReprocessRunActions403 | AuditReportsTriggerReprocessRunActions404>, {id: AuditReportsTriggerReprocessRunActionsPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsTriggerReprocessRunActionsMutationKey()

          const baseOptions = auditReportsTriggerReprocessRunActionsMutationOptions(config) as UseMutationOptions<AuditReportsTriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessRunActions400 | AuditReportsTriggerReprocessRunActions401 | AuditReportsTriggerReprocessRunActions403 | AuditReportsTriggerReprocessRunActions404>, {id: AuditReportsTriggerReprocessRunActionsPathParams["id"]}, TContext>
          

          return useMutation<AuditReportsTriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessRunActions400 | AuditReportsTriggerReprocessRunActions401 | AuditReportsTriggerReprocessRunActions403 | AuditReportsTriggerReprocessRunActions404>, {id: AuditReportsTriggerReprocessRunActionsPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsTriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessRunActions400 | AuditReportsTriggerReprocessRunActions401 | AuditReportsTriggerReprocessRunActions403 | AuditReportsTriggerReprocessRunActions404>, {id: AuditReportsTriggerReprocessRunActionsPathParams["id"]}, TContext>
      
}